import {Directive, effect, ElementRef, inject, input} from '@angular/core';

@Directive({
    selector: '[xuiMatCheckboxBackgroundColour]',
})
export class MatCheckboxBackgroundColourDirective {
  xuiMatCheckboxBackgroundColour = input<string>('');

  private readonly element: HTMLElement = inject(ElementRef).nativeElement;

  constructor() {
    effect(() => {
      const color = this.xuiMatCheckboxBackgroundColour();
      if (!color) {
        return;
      }
      this.element.style.setProperty('--mat-checkbox-selected-icon-color', color);
      this.element.style.setProperty('--mat-checkbox-unselected-icon-color', color);
      this.element.style.setProperty('--mat-checkbox-selected-focus-icon-color', color);
      this.element.style.setProperty('--mat-checkbox-unselected-focus-icon-color', color);
      this.element.style.setProperty('--mat-checkbox-selected-hover-icon-color', color);
      this.element.style.setProperty('--mat-checkbox-unselected-hover-icon-color', color);
    });
  }
}
